import CheckBox from './CheckBox'
import DateInput from './DateInput'
import EmailInput from './EmailInput'
import NumberInput from './NumberInput'
import RadioInput from './RadioInput'
import SelectInput from './SelectInput'
import SelectCheckBoxInput from './SelectCheckBoxInput'
import SliderInput from './SliderInput'
import TextArea from './TextArea'
import TextInput from './TextInput'
import ProgrammeInput from './ProgrammeInput'

export const CustomInputs = {
  CheckBox,
  DateInput,
  EmailInput,
  NumberInput,
  RadioInput,
  SelectInput,
  SelectCheckBoxInput,
  SliderInput,
  TextArea,
  TextInput,
	ProgrammeInput,
}
